import axios from 'axios';
import { BASE_URL} from "./config";

// const API = axios.create({ baseURL: "https://skillop.in" });
const API = axios.create({ baseURL: BASE_URL });

export const sendPlatformFeedback = (data) => {
  const token = localStorage.getItem('skilloptoken');

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
    withCredentials: true,
  };
  return API.post(`/api/feedback/to/platform`, data, config);
};
